<template>
<div class="chapter">
<div class="inner_page">
<div id="Dramatis_Personae">
<p class="fm-title">Dramatis Personae<span epub:type="pagebreak" id="page7"></span></p>
<p class="noindent1">It may be helpful to the reader to have to hand a quick reference guide to the roles of some of the players in this drama and their positions at the time.</p>
<p class="ref">Admiral Reginald Bacon: commanding Dover Patrol 1915–1918</p>
<p class="ref">Admiral Prince Louis Battenberg: First Sea Lord 1912–1914</p>
<p class="ref">Vice Admiral Lewis Bayly: commanding Queenstown and Western Approaches 1915–1919</p>
<p class="ref">Admiral Sir David Beatty: commanding Battle Cruiser Force 1914–1916, Commander-in-Chief Grand Fleet 1916–1919</p>
<p class="ref">Admiral Lord Charles Beresford: MP and retired admiral</p>
<p class="ref">Captain Hugh Brocklebank: captain HMS <i>Changuinola</i></p>
<p class="ref">Admiral Sir George Callaghan: Commander-in-Chief Home Fleet 1911–1914</p>
<p class="ref">Rt Hon Winston Churchill: First Lord of the Admiralty 1911–1915</p>
<p class="ref">Rear Admiral Sir Christopher Cradock: commanding 4th Cruiser Squadron</p>
<p class="ref">Commander Selwyn Day: captain HMS <i>Dundee</i></p>
<p class="ref">Rear Admiral Sir Dudley de Chair: commanding 10th Cruiser Squadron 1914–1916</p>
<p class="ref">Commander (later Captain) George England: captain HMS <i>Orvieto</i></p>
<p class="ref">Admiral of the Fleet Lord John (Jacky) Fisher: First Sea Lord 1904–1910, 1914–1915</p>
<p class="ref">Sir Eric Geddes: First Lord of the Admiralty 1917–1919</p>
<p class="ref">Commander Francis Grenfell: HMS <i>Cedric</i></p>
<p class="ref">Admiral Sir Frederick Hamilton: Second Sea Lord 1914–1916</p>
<p class="ref">Admiral Sir Henry Jackson: Chief of Staff, Admiralty 1913–1915, First Sea Lord 1915–1916</p>
<p class="ref">Admiral Sir John Jellicoe: Commander-in-Chief Grand Fleet 1914–1916, First Sea Lord 1916–1917</p>
<p class="ref">Vice Admiral Roger Keyes: commanding Dover Patrol 1918</p>
<p class="ref">Captain Francis Martin Leake: captain HMS <i>Achilles</i></p>
<p class="ref">Midshipman Ernest McKeag: HMS <i>India</i><span epub:type="pagebreak" id="page8"></span></p>
<p class="ref">Rt Hon Reginald McKenna: First Lord of the Admiralty 1908–1911</p>
<p class="ref">Lieutenant John Shuter: First Lieutenant HMS <i>Changuinola</i></p>
<p class="ref">Rear Admiral Archibald Stoddart: commanding 5th Cruiser Squadron</p>
<p class="ref">Vice Admiral Reginald Tupper: commanding 10th Cruiser Squadron 1916–1917</p>
<p class="ref">Admiral Sir Arthur Wilson: First Sea Lord 1910–1911</p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 08_Dramatis_Personae.vue?45c00163